import { InjectionToken, Injector, inject } from '@angular/core';
import { Analytics, logEvent } from '@angular/fire/analytics';

export interface FirebaseAnalyticsApi {
	getAnalytics: () => Analytics;
	logEvent: (
		analytics: Analytics,
		eventName: string,
		eventParams?: { [key: string]: unknown }
	) => void;
}

export const FIREBASE_ANALYTICS_API = new InjectionToken<FirebaseAnalyticsApi>(
	'FIREBASE_ANALYTICS_API',
	{
		providedIn: 'root',
		factory: (): FirebaseAnalyticsApi => {
			const injector = inject(Injector);
			return {
				// Resolves Angular Fire Analytics only when called (after Accept).
				// provideAnalytics() runs its factory at that point.
				getAnalytics: () => injector.get(Analytics),
				logEvent: (analytics, eventName, eventParams) =>
					logEvent(analytics, eventName, eventParams),
			};
		},
	}
);
